// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/login-background.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.login-password-modala .modal-content {
  color: #fff;
  background-color: #050e25; }

.login {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  text-align: center;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden; }
  .login .form-floating > .form-control:focus ~ label, .login .form-floating > .form-control:not(:placeholder-shown) ~ label, .login .form-floating > .form-control-plaintext ~ label, .login .form-floating > .form-select ~ label {
    color: white;
    opacity: 0.65;
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
  .login .form-floating > .form-control:focus ~ label::after, .login .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .login .form-floating > .form-control-plaintext ~ label::after, .login .form-floating > .form-select ~ label::after {
    background-color: unset; }
  .login .swish {
    height: 100vh;
    position: absolute;
    z-index: 1;
    right: 0; }
  .login .login-icon {
    position: absolute;
    bottom: 7%;
    left: 5%; }
  .login .login-left,
  .login .login-right {
    position: absolute;
    z-index: 2; }
  .login .login-left {
    text-align: left;
    color: white;
    top: calc(47% - 10vw);
    left: 7%; }
    .login .login-left h3 {
      font-size: calc(.5rem + 1.5vw); }
  .login .login-right {
    position: absolute;
    right: 9%;
    top: 17%; }
    .login .login-right .login-input,
    .login .login-right .login-button {
      width: 30vw;
      height: 60px !important;
      border-radius: 10px !important; }
    .login .login-right .login-input::placeholder {
      color: white;
      opacity: .5; }
    .login .login-right .login-btn-box {
      display: flex;
      justify-content: center;
      flex-direction: column; }
    .login .login-right .rand-wrapper input {
      padding-left: 15px !important;
      padding-top: 15px !important; }
    .login .login-right .rand-wrapper label {
      margin-left: unset !important; }
    .login .login-right .rand-wrapper .rand-box {
      display: flex;
      justify-content: space-around; }
      .login .login-right .rand-wrapper .rand-box input {
        width: 14.75vw; }
    .login .login-right .input-wrapper {
      position: relative; }
      .login .login-right .input-wrapper .input-icon {
        position: absolute;
        top: 18px;
        left: 10px; }
      .login .login-right .input-wrapper .name-box {
        display: flex;
        justify-content: space-around; }
        .login .login-right .input-wrapper .name-box input {
          width: 14.75vw; }
    .login .login-right .check-box {
      display: flex;
      color: white; }
      .login .login-right .check-box p {
        margin-left: 4px; }
    .login .login-right .text-box {
      display: flex;
      justify-content: space-between; }
  .login .logo {
    margin-bottom: 40px;
    width: -webkit-fill-available; }
  .login .login-link {
    color: #0d6efd;
    text-decoration: underline;
    cursor: pointer; }
  .login .form-login {
    width: 100%;
    height: 100%;
    text-align: center;
    margin: auto; }
    .login .form-login input {
      padding-left: 5px !important;
      padding-right: 5px !important;
      padding-top: 5px !important;
      padding-bottom: 5px !important; }
    .login .form-login .login-input-icon-shift {
      padding-left: 45px !important; }
    .login .form-login label {
      text-align: unset;
      color: white;
      margin-left: -14rem; }
  .login button.btn-login {
    margin-top: 20px;
    width: 100%; }
  .login .section-2 {
    width: 100%; }
    .login .section-2 a.forgot-password {
      color: #4fc2d9;
      position: absolute;
      right: 10px;
      bottom: 60px; }
    .login .section-2 a.forgot-password:link {
      text-decoration: none; }
    .login .section-2 .form-check {
      text-align: left;
      margin: unset;
      padding: unset; }
      .login .section-2 .form-check input[type="checkbox"] {
        border-color: unset;
        width: 20px;
        height: 20px;
        padding: unset;
        margin: unset;
        background: transparent;
        border: 1px #fff solid;
        margin-right: 10px;
        cursor: pointer; }
      .login .section-2 .form-check input[type="checkbox"]:checked {
        background: #4fc2d9;
        color: #0b1736; }
      .login .section-2 .form-check label.form-check-label {
        text-align: left;
        color: #fff !important; }
  .login .social-button {
    width: 100%;
    padding: 14px 20px;
    margin: 8px 0;
    border: none;
    cursor: pointer;
    font-size: 1.25rem;
    min-height: 3.5rem;
    justify-content: left;
    background: rgba(196, 196, 196, 0.2);
    border-radius: 10px; }
  .login .social-button-img {
    height: 20px;
    width: 20px;
    margin-right: 10px;
    vertical-align: middle; }
  .login .login-options {
    background: #ffffff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 7px;
    width: 100%;
    height: 100%;
    margin: 0 auto 0 5%;
    text-align: center; }
    @media screen and (max-width: 56.25rem) {
      .login .login-options {
        width: 50%;
        margin: auto; } }
  .login .grid {
    width: 50%;
    margin: 0 auto 5% auto; }
    @media screen and (max-width: 56.25rem) {
      .login .grid {
        width: 95%;
        text-align: center; } }
  .login .match {
    color: green; }
  .login .no-match {
    color: red; }

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .login .swish {
    right: unset; }
  .login .input-wrapper input {
    width: 350px !important; }
  .login .login-btn-box .login-button {
    width: 350px;
    height: 60px !important;
    border-radius: 10px !important; } }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/account/login.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACrBrD;EAEM,WDJiB;ECKjB,yBDQkC,EAAA;;ACJxC;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mDAAkD;EAClD,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB,EAAA;EATlB;IAYM,YAAY;IACZ,aAAa;IACb,8DAA8D,EAAA;EAdpE;IAkBM,uBAAuB,EAAA;EAlB7B;IAsBI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,QAAQ,EAAA;EAzBZ;IA6BI,kBAAkB;IAClB,UAAU;IACV,QAAQ,EAAA;EA/BZ;;IAoCI,kBAAkB;IAClB,UAAU,EAAA;EArCd;IAyCI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,QAAQ,EAAA;IA5CZ;MA+CM,8BAA8B,EAAA;EA/CpC;IAoDI,kBAAkB;IAClB,SAAS;IACT,QAAQ,EAAA;IAtDZ;;MAyDM,WAAW;MACX,uBAAuB;MACvB,8BAA8B,EAAA;IA3DpC;MA+DQ,YAAY;MACZ,WAAW,EAAA;IAhEnB;MAoEM,aAAa;MACb,uBAAuB;MACvB,sBAAsB,EAAA;IAtE5B;MA2EU,6BAA6B;MAC7B,4BAA4B,EAAA;IA5EtC;MAgFU,6BAA6B,EAAA;IAhFvC;MAqFQ,aAAa;MACb,6BAA6B,EAAA;MAtFrC;QAwFU,cACF,EAAA;IAzFR;MA8FM,kBAAkB,EAAA;MA9FxB;QAgGQ,kBAAkB;QAClB,SAAS;QACT,UAAU,EAAA;MAlGlB;QAsGQ,aAAa;QACb,6BAA6B,EAAA;QAvGrC;UAyGU,cACF,EAAA;IA1GR;MAgHM,aAAa;MACb,YAAY,EAAA;MAjHlB;QAmHQ,gBAAgB,EAAA;IAnHxB;MAwHM,aAAa;MACb,8BAA8B,EAAA;EAzHpC;IA8HI,mBAAmB;IACnB,6BAA6B,EAAA;EA/HjC;IAmII,cAAc;IACd,0BAA0B;IAC1B,eAAe,EAAA;EArInB;IA2II,WAAW;IACX,YAAY;IAEZ,kBAAkB;IAClB,YAAY,EAAA;IA/IhB;MAiJM,4BAA4B;MAC5B,6BAA6B;MAC7B,2BAA2B;MAC3B,8BAA8B,EAAA;IApJpC;MAuJM,6BAA6B,EAAA;IAvJnC;MA2JM,iBAAiB;MACjB,YAAY;MACZ,mBAAmB,EAAA;EA7JzB;IAkKI,gBAAgB;IAChB,WAAW,EAAA;EAnKf;IAuKI,WAAW,EAAA;IAvKf;MA0KM,cDlLsB;MCmLtB,kBAAkB;MAClB,WAAW;MACX,YAAY,EAAA;IA7KlB;MAgLM,qBAAqB,EAAA;IAhL3B;MAoLM,gBAAgB;MAChB,aAAa;MACb,cAAc,EAAA;MAtLpB;QAyLQ,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,aAAa;QACb,uBAAuB;QACvB,sBAAsB;QACtB,kBAAkB;QAClB,eAAe,EAAA;MAjMvB;QAqMQ,mBD7MoB;QC8MpB,cD7MgB,EAAA;MCOxB;QAyMQ,gBAAgB;QAChB,sBAAmC,EAAA;EA1M3C;IAgNI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,oCAAoC;IACpC,mBAAmB,EAAA;EAzNvB;IA6NI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sBAAsB,EAAA;EAhO1B;IAoOI,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IAKnB,kBAAkB,EAAA;IAJlB;MA1OJ;QA2OM,UAAU;QACV,YAAY,EAAA,EAGf;EA/OH;IAkPI,UAAU;IACV,sBAAsB,EAAA;IAEtB;MArPJ;QAsPM,UAAU;QACV,kBAAkB,EAAA,EAErB;EAzPH;IA4PI,YAAY,EAAA;EA5PhB;IAgQI,UAAU,EAAA;;AAKd;EACE;IAEI,YAAY,EAAA;EAFhB;IAOM,uBAAuB,EAAA;EAP7B;IAaM,YAAY;IACZ,uBAAuB;IACvB,8BAA8B,EAAA,EAC/B","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../../theme/_variables.scss\";\n\n.login-password-modala {\n    .modal-content {\n      color: $primaryFontColor;\n      background-color: $containerScreenBackgroundColor;     \n    }\n}\n\n.login {\n  width: 100vw;\n  height: 100vh;\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n  background: url(../../assets/login-background.svg);\n  background-size: cover;\n  background-repeat: no-repeat;\n  overflow: hidden;\n\n  .form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-control-plaintext ~ label, .form-floating > .form-select ~ label {\n      color: white;   \n      opacity: 0.65;\n      transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n  }\n\n  .form-floating > .form-control:focus ~ label::after, .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .form-floating > .form-control-plaintext ~ label::after, .form-floating > .form-select ~ label::after {\n      background-color: unset; \n  }\n  \n  .swish {\n    height: 100vh;\n    position: absolute;\n    z-index: 1;\n    right: 0;\n  }\n\n  .login-icon {\n    position: absolute;\n    bottom: 7%;\n    left: 5%;\n  }\n\n  .login-left,\n  .login-right {\n    position: absolute;\n    z-index: 2;\n  }\n\n  .login-left {\n    text-align: left;\n    color: white;\n    top: calc(47% - 10vw);\n    left: 7%;\n\n    h3 {\n      font-size: calc(.5rem + 1.5vw);   \n    }\n  }\n\n  .login-right {\n    position: absolute;\n    right: 9%;\n    top: 17%;\n    .login-input,\n    .login-button {\n      width: 30vw;\n      height: 60px !important;\n      border-radius: 10px !important;\n    }\n\n    .login-input::placeholder {\n        color: white;\n        opacity: .5;\n    }\n\n    .login-btn-box {\n      display: flex;\n      justify-content: center;\n      flex-direction: column;\n    }\n\n    .rand-wrapper {\n        input {\n          padding-left: 15px !important;\n          padding-top: 15px !important;\n        }\n\n        label {\n          margin-left: unset !important;\n        }\n\n\n      .rand-box {\n        display: flex;\n        justify-content: space-around;\n        input {\n          width: 14.75vw\n        }\n      }\n    }\n\n    .input-wrapper {\n      position: relative;\n      .input-icon {\n        position: absolute;\n        top: 18px;\n        left: 10px;\n      }\n\n      .name-box {\n        display: flex;\n        justify-content: space-around;\n        input {\n          width: 14.75vw\n        }\n      }\n\n    }\n\n    .check-box {\n      display: flex;\n      color: white;\n      p {\n        margin-left: 4px;\n      }\n    }\n\n    .text-box {\n      display: flex;\n      justify-content: space-between;\n    }\n  }\n\n  .logo {\n    margin-bottom: 40px;\n    width: -webkit-fill-available;\n  }\n\n  .login-link {\n    color: #0d6efd;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n\n\n\n  .form-login {\n    width: 100%;\n    height: 100%;\n\n    text-align: center;\n    margin: auto;\n    input {\n      padding-left: 5px !important;\n      padding-right: 5px !important;\n      padding-top: 5px !important;\n      padding-bottom: 5px !important;\n    }\n    .login-input-icon-shift {\n      padding-left: 45px !important;\n    }\n\n    label {\n      text-align: unset;\n      color: white;\n      margin-left: -14rem;\n    }\n  }\n\n  button.btn-login {\n    margin-top: 20px;\n    width: 100%;\n  }\n\n  .section-2 {\n    width: 100%;\n\n    a.forgot-password {\n      color: $secundaryFontColor;\n      position: absolute;\n      right: 10px;\n      bottom: 60px;\n    }\n    a.forgot-password:link {\n      text-decoration: none;\n    }\n\n    .form-check {\n      text-align: left;\n      margin: unset;\n      padding: unset;\n\n      input[type=\"checkbox\"] {\n        border-color: unset;\n        width: 20px;\n        height: 20px;\n        padding: unset;\n        margin: unset;\n        background: transparent;\n        border: 1px #fff solid;\n        margin-right: 10px;\n        cursor: pointer;\n      }\n\n      input[type=\"checkbox\"]:checked {\n        background: $secundaryFontColor;\n        color: $thirdFontColor;\n      }\n      label.form-check-label {\n        text-align: left;\n        color: $primaryFontColor !important;\n      }\n    }\n  }\n\n  .social-button {\n    width: 100%;\n    padding: 14px 20px;\n    margin: 8px 0;\n    border: none;\n    cursor: pointer;\n    font-size: 1.25rem;\n    min-height: 3.5rem;\n    justify-content: left;\n    background: rgba(196, 196, 196, 0.2);\n    border-radius: 10px;\n  }\n\n  .social-button-img {\n    height: 20px;\n    width: 20px;\n    margin-right: 10px;\n    vertical-align: middle;\n  }\n\n  .login-options {\n    background: #ffffff;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n    border-radius: 7px;\n    width: 100%;\n    height: 100%;\n    margin: 0 auto 0 5%;\n    @media screen and (max-width: 56.25rem) {\n      width: 50%;\n      margin: auto;\n    }\n    text-align: center;\n  }\n\n  .grid {\n    width: 50%;\n    margin: 0 auto 5% auto;\n\n    @media screen and (max-width: 56.25rem) {\n      width: 95%;\n      text-align: center;\n    }\n  }\n\n  .match {\n    color: green;\n  }\n\n  .no-match {\n    color: red;\n  }\n}\n\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {\n  .login {\n    .swish {\n      right: unset;\n    }\n\n    .input-wrapper {\n      input {\n        width: 350px !important;\n      }\n    }\n\n    .login-btn-box {\n      .login-button {\n        width: 350px;\n        height: 60px !important;\n        border-radius: 10px !important;\n      }\n    }\n  }\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
